export const getPermissions = () => {
  const storedPermissions = localStorage.getItem('permissions');
  if (storedPermissions) {
    return JSON.parse(storedPermissions);
  } else {
    return []; // Return an empty array or handle the case where no permissions are stored
  }
};
